import type { LucideIcon } from "lucide-react";
import { AlertTriangle, Database } from "lucide-react";

type EmptyStateProps = {
  title?: string;
  message?: string;
  icon?: LucideIcon;
};

export function SomethingWentWrong({
  icon: Icon = AlertTriangle,
  message = "Something went wrong.",
}: EmptyStateProps) {
  return (
    <div className="mx-auto mt-10 flex max-w-md flex-col items-center justify-center p-6">
      <Icon className="mb-4 size-12 text-red-500" />
      <h3 className="text-l mb-2 font-semibold text-red-700">{message}</h3>
      <p className="text-center text-sm text-red-600">
        Please try again later or contact support.
      </p>
    </div>
  );
}

export function NoDataAvailable({
  title = "No Data Available",
  message = "There is currently no data to display.",
  icon: Icon = Database,
}: EmptyStateProps) {
  return (
    <div className="mx-auto mt-10 flex max-w-md flex-col items-center justify-center p-6">
      <Icon className="mb-4 size-12 text-gray-400" />
      <h3 className="text-l mb-2 font-semibold text-gray-700">{title}</h3>
      <p className="text-center text-sm text-gray-500">{message}</p>
    </div>
  );
}
